import { Node } from 'tiptap'
import { replaceText } from 'tiptap-commands'
import { SuggestionsPlugin, Mention as MentionOriginal } from 'tiptap-extensions'

export default class User extends MentionOriginal {

  get name() {
    return 'user'
  }

  get defaultOptions() {
    return {
      matcher: {
        char: '@',
        allowSpaces: false,
        startOfLine: false,
      },
      mentionClass: 'user',
      suggestionClass: 'user-suggestion',
    }
  }

  get schema() {
    return {
      attrs: {
        id: {},
        label: {},
      },
      group: 'inline',
      inline: true,
      selectable: false,
      atom: true,
      toDOM: node => [
        'span',
        {
          class: this.options.mentionClass,
          'data-user-id': node.attrs.id,
          'data-char': this.options.matcher.char,
        },
        `${node.attrs.label}`,
      ],
      parseDOM: [
        {
          tag: 'span[data-user-id]',
          getAttrs: dom => {
            const id = dom.getAttribute('data-user-id')
            const label = dom.innerText.split(this.options.matcher.char).join('')
            return { id, label }
          },
        },
      ],
    }
  }

}
